import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { MessageSquare, Send } from 'lucide-react';
import { toast } from 'sonner';

export default function PageMessaging({ pageTitle, pageNumber }) {
  const [message, setMessage] = useState('');
  const [recipient, setRecipient] = useState('instructor');
  const [isSending, setIsSending] = useState(false);

  const sendMessage = async () => {
    const userId = localStorage.getItem('workbook_user_id');
    const userName = localStorage.getItem('workbook_user_name');
    const userEmail = localStorage.getItem('workbook_user_email');
    
    if (!message.trim()) {
      toast.error('Please enter a message');
      return;
    }

    setIsSending(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact-requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: userName || 'User',
          email: userEmail || 'user@example.com',
          type: 'workbook_message',
          phone: '',
          interest: recipient,
          comments: `${message}\n\nContext: ${pageTitle} (Page ${pageNumber})`,
          contactPreference: 'email'
        })
      });

      if (response.ok) {
        toast.success('Message sent to admin!');
        setMessage('');
      } else {
        toast.error('Failed to send message');
      }
    } catch (error) {
      toast.error('Error sending message');
    }
    setIsSending(false);
  };

  return (
    <div className="bg-gradient-to-br from-blue-900/20 to-cyan-900/20 border border-blue-700/30 rounded-lg p-6 mt-6">
      <div className="flex items-center gap-3 mb-4">
        <MessageSquare className="h-6 w-6 text-blue-400" />
        <h3 className="text-xl font-bold text-white">Ask a Question or Share Insights</h3>
      </div>
      
      <p className="text-blue-100 mb-4 text-sm">
        Message your instructor or fellow students about this page.
      </p>

      <div className="space-y-4">
        <div>
          <label className="text-blue-200 text-sm mb-2 block">Send to:</label>
          <Select value={recipient} onValueChange={setRecipient}>
            <SelectTrigger className="bg-blue-900/20 border-blue-700/30 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="instructor">Instructor</SelectItem>
              <SelectItem value="all-students">All Students</SelectItem>
              <SelectItem value="study-partner">My Study Partner</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="text-blue-200 text-sm mb-2 block">Your message:</label>
          <Textarea 
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Ask a question, share an insight, or request clarification..."
            className="bg-blue-900/20 border-blue-700/30 text-white placeholder:text-blue-300/40 min-h-[100px]"
          />
          <p className="text-blue-300/60 text-xs mt-1">Context: {pageTitle} (Page {pageNumber})</p>
        </div>

        <Button 
          onClick={sendMessage}
          disabled={isSending}
          className="bg-blue-600 hover:bg-blue-500 text-white w-full"
        >
          <Send className="h-4 w-4 mr-2" />
          {isSending ? 'Sending...' : 'Send Message'}
        </Button>
      </div>
    </div>
  );
}
